import React from "react";
import { FormBuilder } from "../../../../components/form/FormBuilder";
import { forms } from "../../../../shared/static/forms";
import { store } from "../../../../redux/store";
import { hideModal } from "../../../../connected-components/modal/reducer";

const AddNewDoctor: React.FC = () => {
  const handleSubmit = (value: any) => {
    // Here you would typically make an API call to save the doctor
    console.log("New doctor data:", value);
    
    // Close the modal after successful submission
    store.dispatch(hideModal());
  };

  return (
    <div className="w-full pt-4">
      <FormBuilder
        schema={forms.addNewDoctor}
        gridConfig={{ mobile: 1, desktop: 3 }}
        initialValues={{ status: "Active", emergencyPrivileges: "false" }}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default AddNewDoctor;
